export const projects = [

	{
		img: 'https://i.ibb.co/c6qPMG1/Myntra-Home-Page-jpg.jpg',
		title: 'Clone of Myntra',
		des: 'This is a clone of Myntra which is an Indian ecommerce website. The clone is complete with a Login page, Sign-in page, Shopping Cart, Wishlist and Add to Bag. Following is the link to the clone of the website.',
		live: 'https://myntracloneusingredux.netlify.app/',
		demo: '',
		gitHub: 'https://github.com/Danisk43/MyntraHerokuNetlify',
		technologies: ['HTML','CSS','javaScript',"React","Redux"],
	},
	{
		img: 'https://i.ibb.co/b6YdVv5/sai-Solutions-homepage.png',
		title: 'Sai Solution(a complete stop for all your interior needs) construction company website',
		des: 'This is a website for construction company built with collaboration with Kanhaiya Suthar',
		demo: '',
		live: 'https://saisolutions.netlify.app/',
		gitHub: 'https://github.com/Danisk43/saisolutions',
		technologies: ['HTML', 'CSS', 'javaScript','React','lazy load','material ui','bootstrap'],
	},
];
